// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_FiscalConfigResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET|POST|PUT /subaccounts/invoices/fiscal_config/{franchise_id}
 * (routed to subaccounts/invoice_config/fiscal_config).
 *
 * `config` is intentionally a loose ?array, not a fixed set of typed
 * properties — the shape stored in subaccounts.fiscal_config differs by
 * country (Chile: rut_empresa/razon_social/giro/...; Brazil: cnpj/
 * inscricao_municipal/...), decided by Invoice_config::getFiscalConfig().
 * Same pattern as Invoice_FiscalRequirementsRow::$config_schema, which is
 * also a per-provider dynamic map.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Invoice_FiscalConfigResponseDados {
franchise_id: number
config: Record<string, string | boolean | number | null>
is_configured: boolean
}

export type Invoice_FiscalConfigResponse = ApiResponse<Invoice_FiscalConfigResponseDados>;

registerResponseContract('Invoice_FiscalConfigResponse', {
  franchise_id:  { type: 'number',  required: true },
  config:        { type: 'object',  required: false },
  is_configured: { type: 'boolean', required: true },
})
